(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("question", [], factory);
	else if(typeof exports === 'object')
		exports["question"] = factory();
	else
		root["question"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 